import cancello_ingresso1 from '../../photos/Case/Facciata/cancello ingresso 1.jpg';
import cancello_ingresso2 from '../../photos/Case/Facciata/cancello ingresso 2.jpg';

import esterno_primo_piano1 from '../../photos/Case/Facciata/esterno primo piano 1.jpg';
import esterno_primo_piano1_2 from '../../photos/Case/Facciata/esterno primo piano 1_2.jpg';
import esterno_primo_piano2 from '../../photos/Case/Facciata/esterno primo piano 2_sfondo_verticale.jpg';
import esterno_primo_piano3 from '../../photos/Case/Facciata/esterno primo piano_sfondo_orizzontale.jpg';
import esterno_primo_piano4 from '../../photos/Case/Facciata/esterno primo piano 3.jpg';
import terrazza_primo_piano from '../../photos/Case/Facciata/terrazza primo piano.jpg';

import ingresso from '../../photos/Case/Primo piano/Esterno primo piano/Ingresso.jpg';
import cancelletto from '../../photos/Case/Primo piano/Esterno primo piano/Cancelletto veranda.jpg';
import veranda1 from '../../photos/Case/Primo piano/Esterno primo piano/Veranda.jpg';
import veranda2 from '../../photos/Case/Primo piano/Esterno primo piano/Veranda 2.jpg';
import veranda3 from '../../photos/Case/Primo piano/Esterno primo piano/Veranda 3.jpg';
import fiori from '../../photos/Case/Primo piano/Esterno primo piano/Fiori in veranda.jpg';
import ombrellone1 from '../../photos/Case/Primo piano/Esterno primo piano/Ombrellone veranda.jpg';
import ombrellone2 from '../../photos/Case/Primo piano/Esterno primo piano/Ombrellone veranda 2.jpg';
import tavolo_esterno from '../../photos/Case/Primo piano/Esterno primo piano/Tavolo esterno.jpg';
import divani_esterno from '../../photos/Case/Primo piano/Esterno primo piano/Divani esterno.jpg';
import colazione from '../../photos/Case/Primo piano/Esterno primo piano/Colazione esterno.jpg';
import barbecue from '../../photos/Case/Primo piano/Esterno primo piano/Barbecue.jpg';

import angolo_cottura from '../../photos/Case/Primo piano/Angolo cottura.jpg';
import lavanderia from '../../photos/Case/Primo piano/Lavanderia.jpg';
import frigo from '../../photos/Case/Primo piano/Frigorifero.jpg';
import soggiorno from '../../photos/Case/Primo piano/Soggiorno.jpg';
import tavolo from '../../photos/Case/Primo piano/Tavolo da pranzo.jpg';
import divano from '../../photos/Case/Primo piano/Divano soggiorno.jpg';
import ombrellone_spiaggia from '../../photos/Case/Primo piano/Ombrellone e sedie spiaggia.jpg';
import condizionatore from '../../photos/Case/Primo piano/Condizionatore.jpg';
import corridoio from '../../photos/Case/Primo piano/Corridoio.jpg';
import particolare_corridoio from '../../photos/Case/Primo piano/Particolare corridoio.jpg';
import camera_matrimoniale from '../../photos/Case/Primo piano/Camera matrimoniale.jpg';
import appendino_camera_matrimoniale from '../../photos/Case/Primo piano/Appendino camera matrimoniale.jpg';
import finestra_camera_matrimoniale from '../../photos/Case/Primo piano/Finestra camera matrimoniale.jpg';
import camera_doppia from '../../photos/Case/Primo piano/Camera doppia.jpg';
import testata_letto from '../../photos/Case/Primo piano/Testata letto camera doppia.jpg';
import camera_doppia_trasf from '../../photos/Case/Primo piano/Camera doppia trasformata in matrimoniale.jpg';
import armadio1 from '../../photos/Case/Primo piano/Armadio camera doppia 1.jpg';
import armadio2 from '../../photos/Case/Primo piano/Armadio camera doppia 2.jpg';
import appendino_camera_doppia from '../../photos/Case/Primo piano/Appendino camera doppia.jpg';
import balcone from '../../photos/Case/Primo piano/Balcone camera doppia.jpg';
import bagno from '../../photos/Case/Primo piano/Bagno.jpg';
import doccia from '../../photos/Case/Primo piano/Doccia.jpg';
import particolare_bagno from '../../photos/Case/Primo piano/Particolare bagno.jpg';

import colonnina from '../../photos/Case/Primo piano/Colonnina ricarica elettrica.jpg';

import bici1 from '../../photos/Case/Primo piano/Biciclette 1.jpg';
import bici2 from '../../photos/Case/Primo piano/Biciclette 2.jpg';

const DataHousePage2 = [
    {
        src: cancello_ingresso1,
        title: 'Esterno Appartamenti',
        description: 'Cancello d\'ingresso degli appartamenti',
    },
    {
        src: cancello_ingresso2,
        title: 'Esterno Appartamenti',
        description: 'Cancello d\'ingresso degli appartamenti',
    },
    {
        src: esterno_primo_piano1,
        title: 'Esterno Primo Piano',
        description: 'Esterno della casa del primo piano',
    },
    {
        src: esterno_primo_piano1_2,
        title: 'Esterno Primo Piano',
        description: 'Esterno della casa del primo piano',
    },
    {
        src: esterno_primo_piano2,
        title: 'Esterno Primo Piano',
        description: 'Esterno della casa del primo piano',
    },
    {
        src: esterno_primo_piano3,
        title: 'Esterno Primo Piano',
        description: 'Esterno della casa del primo piano',
    },
    {
        src: esterno_primo_piano4,
        title: 'Esterno Primo Piano',
        description: 'Esterno della casa del primo piano',
    },
    {
        src: terrazza_primo_piano,
        title: 'Esterno Primo Piano',
        description: 'Terrazza',
    },
    {
        src: ingresso,
        title: 'Esterno Primo Piano',
        description: 'Ingresso',
    },
    {
        src: cancelletto,
        title: 'Esterno Primo Piano',
        description: 'Cancelletto della veranda',
    },
    {
        src: veranda1,
        title: 'Esterno Primo Piano',
        description: 'Veranda',
    },
    {
        src: veranda2,
        title: 'Esterno Primo Piano',
        description: 'Veranda',
    },
    {
        src: veranda3,
        title: 'Esterno Primo Piano',
        description: 'Veranda',
    },
    {
        src: fiori,
        title: 'Esterno Primo Piano',
        description: 'Fiori in veranda',
    },
    {
        src: ombrellone1,
        title: 'Esterno Primo Piano',
        description: 'Ombrellone della veranda',
    },
    {
        src: ombrellone2,
        title: 'Esterno Primo Piano',
        description: 'Ombrellone della veranda',
    },
    {
        src: tavolo_esterno,
        title: 'Esterno Primo Piano',
        description: 'Tavolo esterno',
    },
    {
        src: divani_esterno,
        title: 'Esterno Primo Piano',
        description: 'Divani esterno',
    },
    {
        src: colazione,
        title: 'Esterno Primo Piano',
        description: 'Colazione in veranda',
    },
    {
        src: barbecue,
        title: 'Esterno Primo Piano',
        description: 'Barbecue',
    },
    {
        src: angolo_cottura,
        title: 'Interno Primo Piano',
        description: 'Angolo cottura',
    },
    {
        src: lavanderia,
        title: 'Interno Primo Piano',
        description: 'Lavanderia',
    },
    {
        src: frigo,
        title: 'Interno Primo Piano',
        description: 'Frigorifero',
    },
    {
        src: soggiorno,
        title: 'Interno Primo Piano',
        description: 'Soggiorno',
    },
    {
        src: tavolo,
        title: 'Interno Primo Piano',
        description: 'Tavolo da pranzo',
    },
    {
        src: divano,
        title: 'Interno Primo Piano',
        description: 'Divano del soggiorno',
    },
    {
        src: ombrellone_spiaggia,
        title: 'Interno Primo Piano',
        description: 'Ombrellone e sedie spiaggia',
    },
    {
        src: condizionatore,
        title: 'Interno Primo Piano',
        description: 'Condizionatore',
    },
    {
        src: corridoio,
        title: 'Interno Primo Piano',
        description: 'Corridoio',
    },
    {
        src: particolare_corridoio,
        title: 'Interno Primo Piano',
        description: 'Particolare del corridoio',
    },
    {
        src: camera_matrimoniale,
        title: 'Interno Primo Piano',
        description: 'Camera matrimoniale',
    },
    {
        src: appendino_camera_matrimoniale,
        title: 'Interno Primo Piano',
        description: 'Appendino della camera matrimoniale',
    },
    {
        src: finestra_camera_matrimoniale,
        title: 'Interno Primo Piano',
        description: 'Finestra della camera matrimoniale',
    },
    {
        src: camera_doppia,
        title: 'Interno Primo Piano',
        description: 'Camera doppia',
    },
    {
        src: testata_letto,
        title: 'Interno Primo Piano',
        description: 'Testata letto della camera doppia',
    },
    {
        src: camera_doppia_trasf,
        title: 'Interno Primo Piano',
        description: 'Camera doppia trasfrormata a matrimoniale',
    },
    {
        src: armadio1,
        title: 'Interno Primo Piano',
        description: 'Armadio della camera doppia',
    },
    {
        src: armadio2,
        title: 'Interno Primo Piano',
        description: 'Armadio camera doppia',
    },
    {
        src: appendino_camera_doppia,
        title: 'Interno Primo Piano',
        description: 'Appendino della camera doppia',
    },
    {
        src: balcone,
        title: 'Interno Primo Piano',
        description: 'Balcone della camera doppia',
    },
    {
        src: bagno,
        title: 'Interno Primo Piano',
        description: 'Bagno',
    },
    {
        src: doccia,
        title: 'Interno Primo Piano',
        description: 'Doccia',
    },
    {
        src: particolare_bagno,
        title: 'Interno Primo Piano',
        description: 'Particolare del bagno',
    },
    {
        src: colonnina,
        title: 'Colonnina ricarica elettrica',
        description: 'Colonnina per la ricarica elettrica',
    },
    {
        src: bici1,
        title: 'Biciclette',
        description: 'Biciclette',
    },
    {
        src: bici2,
        title: 'Bicilette',
        description: 'Bicilette',
    },
]
export default DataHousePage2;